export const space = {
  '0': '0rem', // 0px
  '4XS': '0.125rem', // 2px
  '3XS': '0.25rem', // 4px
  '2XS': '0.375rem', // 6px
  XS: '0.5rem', // 8px
  S: '0.625rem', // 10px
  M: '0.75rem', // 12px
  L: '0.875rem', // 14px
  XL: '1rem', // 16px
  '2XL': '1.125rem', // 18px
  '3XL': '1.25rem', // 20px
  '4XL': '1.5rem', // 24px
  '5XL': '1.75rem', // 28px
  '6XL': '2rem', // 32px
  '7XL': '2.5rem', // 40px
  '8XL': '2.75rem', // 44px
  '9XL': '3rem', // 48px
  '10XL': '3.5rem', // 56px
  '11XL': '4rem', // 64px
  '12XL': '4.5rem', // 72px
}

export type SpaceTokens = {
  [K in keyof typeof space]: string
}
export type SpaceKeys = keyof typeof space
